export function formatDrillDownOrderData(data) {
  return (
    data
      // .filter((item) => item.data.length > 0)
      .map((item) => {
        return {
          businessId: item.businessId,
          orderCount: item?.data[0]?.orderCount || "",
          totalSales: item?.data[0]?.totalSales || "",
        };
      })
      .sort((a, b) => (b.orderCount || 0) - (a.orderCount || 0))
  );
}
